import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';

import './scss/app.scss';
import './i18n';

const selector = 'div[nol-faq]';
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(selector).forEach(el => {
    ReactDOM.createRoot(el).render(
      <React.StrictMode>
        <App config={{
          locale: el.dataset?.locale || 'en',
          url: el.dataset?.url || '',
          question: el.dataset?.question || null,
        }} />
      </React.StrictMode>
    );
  });
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
